/**
 * Adapted from https://inclusive-components.design/collapsible-sections/
 */

// Function to create a node list
// of the content between this heading and the next
function getContent ($el, level) {
  let $$els = []
  while (
    $el.nextElementSibling &&
    $el.nextElementSibling.tagName !== `H${level}`
  ) {
    $$els.push($el.nextElementSibling)
    $el = $el.nextElementSibling
  }

  // Delete the old versions of the content nodes
  $$els.forEach(node => {
    node.parentNode.removeChild(node)
  })

  return $$els
}

function moveChildren ($from, $to) {
  while ($from.childNodes.length) {
    $to.appendChild($from.childNodes[0])
  }
}

function insertAfter ($newNode, $referenceNode) {
  $referenceNode.parentNode.insertBefore($newNode, $referenceNode.nextSibling)
}

export default function collapse (
  $el,
  { level = 2, contentClass = '', delay = 300 } = {}
) {
  let $headings = $el.querySelectorAll(`h${level}`)

  Array.prototype.forEach.call($headings, $heading => {
    // Give each heading a toggle button child
    let $btn = document.createElement('button')
    $btn.setAttribute('aria-expanded', 'false')

    moveChildren($heading, $btn)
    $btn.className = $heading.className
    $btn.style.cssText = $heading.style.cssText
    $heading.className = ''
    $heading.style.cssText = ''
    $heading.appendChild($btn)

    // Assign the contents to be expanded/collapsed (array)
    let $$contents = getContent($heading, level)

    // Create a wrapper element for `contents` and hide it
    let $wrapper = document.createElement('div')
    $wrapper.className = contentClass
    $wrapper.hidden = true

    // Add each element of `contents` to `wrapper`
    $$contents.forEach($node => {
      $wrapper.appendChild($node)
    })

    // Add the wrapped content back into the DOM
    // after the heading
    $heading.parentNode.insertBefore($wrapper, $heading.nextElementSibling)

    let isVisible = false

    $btn.addEventListener('click', () => {
      let expanded = $btn.getAttribute('aria-expanded') === 'true' || false
      $btn.setAttribute('aria-expanded', !expanded)

      isVisible = !expanded

      if (isVisible) {
        $wrapper.style.height = 0
        $wrapper.hidden = false
        $wrapper.style.height = `${$wrapper.scrollHeight}px`
      } else {
        $wrapper.style.height = 0
        window.setTimeout(() => {
          if (!isVisible) {
            $wrapper.hidden = true
          }
        }, delay)
      }
    })
  })

  return () => {
    Array.prototype.forEach.call($headings, $heading => {
      let $btn = $heading.firstChild
      moveChildren($btn, $heading)
      $heading.className = $btn.className
      $heading.style.cssText = $btn.style.cssText

      $heading.removeChild($btn)

      let $content = $heading.nextElementSibling
      while ($content.childNodes.length) {
        insertAfter($content.childNodes[0], $heading)
      }
      $content.parentNode.removeChild($content)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/components/collapse.js